import styled from 'styled-components';

const Title = styled.h1`
  color: #100b2b;
  font-family: 'Eina 01 Bold', san-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
`;

export default Title;
